"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VRModeNoOrientationControlsDialogue = exports.LegacyIOSBlanketEnableOrientationControlsDialogue = exports.IOSEnableOrientationControlsDialogue = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = __importDefault(require("../../../../scss/colors"));
const InlineButton_1 = __importDefault(require("../../../../uikit/InlineButton"));
const DialogueWrapper = styled_components_1.default.div `
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: ${colors_1.default.grey1};
    z-index: 9999999999;
    text-align: center;
`;
const Info = styled_components_1.default.div `
    width: 80%;
    margin: 4% auto;
    text-align: center;
    color: ${colors_1.default.grey11};
`;
const HowTo = styled_components_1.default.img `
    width: 50%;
`;
const IOSEnableOrientationControlsDialogue = ({ onButtonClick: handleButtonClick, }) => {
    return (react_1.default.createElement(DialogueWrapper, null,
        react_1.default.createElement("h3", null, "Enable orientation controls"),
        react_1.default.createElement(Info, null,
            react_1.default.createElement("p", null, "WebVR requires orientation controls to work."),
            react_1.default.createElement("br", null),
            react_1.default.createElement("br", null),
            react_1.default.createElement(InlineButton_1.default, { onClick: handleButtonClick }, "Click to Enable"))));
};
exports.IOSEnableOrientationControlsDialogue = IOSEnableOrientationControlsDialogue;
const LegacyIOSBlanketEnableOrientationControlsDialogue = ({ onButtonClick: handleButtonClick, }) => {
    return (react_1.default.createElement(DialogueWrapper, null,
        react_1.default.createElement("h3", null, "Update Settings"),
        react_1.default.createElement(Info, null,
            react_1.default.createElement("p", null, "To enable Virtual Reality for iOS 13.0 or below:"),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "Settings > Safari > Motion & Orientation Access")),
            react_1.default.createElement("br", null),
            react_1.default.createElement("br", null),
            react_1.default.createElement(InlineButton_1.default, { onClick: handleButtonClick }, "Dismiss Instructions")),
        react_1.default.createElement(HowTo, { src: require("../assets/iOS-safari-close.gif") })));
};
exports.LegacyIOSBlanketEnableOrientationControlsDialogue = LegacyIOSBlanketEnableOrientationControlsDialogue;
const VRModeNoOrientationControlsDialogue = ({ onButtonClick: handleButtonClick, }) => {
    return (react_1.default.createElement(DialogueWrapper, null,
        react_1.default.createElement("h3", null, "Motion Sensors Unavailable"),
        react_1.default.createElement(Info, null,
            react_1.default.createElement("p", null, "We can\u2019t access motion sensors on your device."),
            react_1.default.createElement("p", null, "You can still use touch controls to look around."),
            react_1.default.createElement("br", null),
            react_1.default.createElement("br", null),
            react_1.default.createElement(InlineButton_1.default, { onClick: handleButtonClick }, "Continue"))));
};
exports.VRModeNoOrientationControlsDialogue = VRModeNoOrientationControlsDialogue;
